var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bottom-bar-reminders",
    transform: "translate(-172 -753)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blankbox",
    width: 16,
    height: 16,
    transform: "translate(172 753)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2243",
    "data-name": "Group 2243",
    transform: "translate(174.285 754.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4479",
    "data-name": "Path 4479",
    d: "M18.259,33.452l-.615.946a.4.4,0,0,0,.117.549.4.4,0,0,0,.549-.117l.6-.924a5.735,5.735,0,0,0,5.872,0l.6.924a.4.4,0,1,0,.667-.432l-.613-.946a5.751,5.751,0,1,0-7.177,0ZM21.848,24a4.959,4.959,0,1,1-4.959,4.959A4.963,4.963,0,0,1,21.848,24Z",
    transform: "translate(-16.095 -22.44)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4480",
    "data-name": "Path 4480",
    d: "M179.5,88.546a.4.4,0,1,0,.524-.6l-1.452-1.272V83.486a.4.4,0,0,0-.793,0v3.372a.4.4,0,0,0,.135.3Z",
    transform: "translate(-172.418 -80.337)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4481",
    "data-name": "Path 4481",
    d: "M28.41,2.064a.4.4,0,0,0,.284-.119,6.627,6.627,0,0,1,1.589-1.2.4.4,0,0,0-.375-.7,7.351,7.351,0,0,0-1.783,1.343.4.4,0,0,0,.006.561.406.406,0,0,0,.28.113Z",
    transform: "translate(-27.616 0)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4482",
    "data-name": "Path 4482",
    d: "M276.782.748a6.538,6.538,0,0,1,1.589,1.2.4.4,0,1,0,.567-.555A7.363,7.363,0,0,0,277.155.047a.4.4,0,1,0-.373.7Z",
    transform: "translate(-267.943 -0.001)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderIcon);
export default __webpack_public_path__ + "static/media/reminder-icon.476dc19c3b5b41aac5d49d7aedf9d9bf.svg";
export { ForwardRef as ReactComponent };